export interface GdprSection {
    heading: string;
    paragraphs: (string | { type: "list"; items: (string | { text: string; href: string })[] })[];
}

export const gdprContentNo: GdprSection[] = [
    {
        heading: "Personvern, nettbasert behandling av personopplysninger",
        paragraphs: [
            "Denne personvernerklæringen gjelder for SUROFI sine nettsteder. SUROFI (org. no. 916 437 110) er behandlingsansvarlig for personopplysninger som samles inn på nettsidene surofi.no. Ta kontakt med Surofi for ytterligere informasjon om vilkår som gjelder for øvrige tjenester.",
        ],
    },
    {
        heading: "Introduksjon - definisjoner",
        paragraphs: [
            "Med \"personopplysninger\" mener vi enhver opplysning om en identifisert eller identifiserbar fysisk person, jf. personvernforordningen. En identifiserbar fysisk person er en person som direkte eller indirekte kan identifiseres, ved hjelp av f.eks. et navn, et identifikasjonsnummer, lokaliseringsopplysninger eller en online-identifikator.",
            "Med \"behandling av personopplysninger\" mener vi enhver operasjon eller rekke av operasjoner som gjøres med personopplysninger, enten automatisert eller ikke.",
            "SUROFI er behandlingsansvarlig, dvs. den som bestemmer formålet med behandlingen av personopplysninger og hvilke midler som skal benyttes.",
        ],
    },
    {
        heading: "Personopplysninger som behandles",
        paragraphs: [
            "SUROFI innhenter en begrenset mengde personopplysninger for registrering av brukertilgang til selskapets lukkede nettsider og for å oppfylle avtalen med deg som bruker av tjenesten. SUROFI samler ikke inn identifiserende opplysninger via informasjonskapsler ved besøk på selskapets åpne websider.",
            "Eksempler på informasjon som innhentes for brukerregistrering:",
            { type: "list", items: ["Fornavn og etternavn", "E-postadresse", "Firma- og/eller fartøytilknytning", "Organisasjonsnummer", "Telefonnummer"] },
            "Vi lagrer også informasjon som oppstår når du bruker tjenesten.",
            "Eksempler på informasjon som innhentes ved bruk etter innlogging:",
            { type: "list", items: ["Informasjon om din bruk av nettsidene, blant annet i form av hvilke undersider som besøkes, aktiviteter som utføres, nettleserinstillinger og IP-adresse."] },
            "SUROFI samler ikke inn personopplysninger som fødselsdato- og personnummer, eller opplysninger om personlige betalingskort, for pålogging ved bruk av selskapet nettsider.",
        ],
    },
    {
        heading: "Hvordan informasjon innhentes?",
        paragraphs: [
            "SUROFI innhenter i hovedsak brukeropplysninger for registrering via telefonkontakt med den som ønsker brukertilgang eller etter mottak av brukerregistreringsskjema. Det er frivillig å oppgi denne informasjonen. Hvis du velger ikke å oppgi personopplysningene som er nødvendig for brukerregistrering, kan vi være forhindret fra å gi deg tilgang til tjenesten.",
            "Eksempel på skjema:",
            { type: "list", items: [{ text: "Brukeravtale Surofi Nettsted", href: "https://cdn.prod.website-files.com/61b713822c3b355a0233e377/697c6f0ab79bc22915230c6e_SUROFI_Brukeravtale-2026.pdf" }] },
        ],
    },
    {
        heading: "Formålet med informasjonen som innhentes",
        paragraphs: [
            { type: "list", items: ["For å kunne gi tilgang til våre tjenester", "For å kunne gi relevant informasjon"] },
            "Vi oppretter profiler på bakgrunnen av informasjonen som innhentes, der bruker tilordnes brukerkategori(er) og tilgangsrettigheter i overensstemmelse med kundeforholdet. Profilene baseres på informasjon som du frivillig gir oss, og vi henter ikke inn informasjon for dette formålet fra tredjepart.",
            "Vi vil kun bruke oppgitt kontaktinformasjon til å kommunisere med deg om forhold som er relevante for tjenesten og din bruk av denne.",
        ],
    },
    {
        heading: "Hvordan lagres informasjonen?",
        paragraphs: [
            "Innhentet brukerinformasjon lagres i vår brukerbase. Vi lagrer dine personopplysninger så lenge du benytter deg av tjenesten, og det er nødvendig for de formål som er beskrevet i disse retningslinjene, jfr. avsnittene om behandling og innhenting ovenfor.",
        ],
    },
    {
        heading: "Sikkerhet",
        paragraphs: [
            "Vi lagrer dine personopplysninger på en sikker måte på servere som er tilgangsbegrenset og beskyttet. Det er kun et begrenset antall personer som har fysisk tilgang til dette utstyret og kun personer som har behov for det har tilgang til dine personopplysninger.",
        ],
    },
    {
        heading: "Tilgang, sletting og utlevering",
        paragraphs: [
            "Brukere har tilgang til sine egne brukeropplysninger. Informasjon slettes på oppfordring ved å kontakte SUROFI.",
            "Personopplysningene deles ikke med utenforstående tredjepart, men SUROFI kan bruke underleverandører til å levere hele eller deler av nettsidene. Slike underleverandører kan behandle personopplysninger på vegne av SUROFI.",
        ],
    },
    {
        heading: "Rettigheter",
        paragraphs: [
            "Som bruker av nettsidene våre har du rett til å kreve innsyn i personopplysningene som vi behandler om deg og hvordan de behandles. Du kan også kreve retting, sletting og begrensninger i behandlingen av personopplysninger i henhold til personopplysningsloven.",
            "Hvor behandlingen av personopplysninger er basert på samtykke, kan du til enhver tid trekke samtykket tilbake.",
            "Dersom du mener SUROFI ikke har overholdt dine rettigheter i henhold til personopplysningsloven, har du rett til å klage til den aktuelle tilsynsmyndigheten. Dette gjøres ved å sende klage til Datatilsynet, kontaktinformasjon er tilgjengelig på www.datatilsynet.no.",
        ],
    },
    {
        heading: "Endringer",
        paragraphs: [
            "Tjenesten er gjenstand for konstant forbedring og fremtidige endringer kan påvirke måten vi behandler dine personopplysninger. Disse retningslinjene vil bli oppdatert for å reflektere slike endringer, endringer av lover og regler eller andre endringer i måten vi håndterer personopplysninger. Gjeldende versjon av retningslinjene finner du på www.surofi.no.",
        ],
    },
    {
        heading: "Kontaktinformasjon",
        paragraphs: [
            "Telefon 70 10 24 00 — post@surofi.no — SUROFI, Røysegata 15, 6003 Ålesund",
        ],
    },
];

export const gdprContentEn: GdprSection[] = [
    {
        heading: "Privacy, web-based processing of personal data",
        paragraphs: [
            "This privacy policy applies to SUROFI's websites. SUROFI (org. no. 916 437 110) is the data controller for personal data collected on the website surofi.no.",
        ],
    },
    // Add remaining English sections as needed
];